/* istanbul ignore file */
import { boolean as codecBoolean, string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { TenantRoleWithTenant } from './TenantRoleWithTenant';
const AllowRegistrationDomainParser = 
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('allow')],
    ['id', codecString],
    ['domain', codecString],
    ['matchSubdomains', codecBoolean, 'match_subdomains'],
    ['tenantRole', TenantRoleWithTenant, 'tenant_role'],
]);
export class AllowRegistrationDomain extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AllowRegistrationDomainParser.decode(input).map(res => new AllowRegistrationDomain(res));
    }
    static unsafeDecode(input) {
        return AllowRegistrationDomain.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AllowRegistrationDomainParser.encode(data);
    }
    static schema() {
        return AllowRegistrationDomainParser.schema();
    }
}
